<template>
  <div>
    <v-text-field
      v-if="searchable"
      v-model="search"
      hideDetails
      clearable
      appendIcon="mdi-magnify"
    />
    <ValidationProvider
      :ref="validationProviderRef"
      :mode="veeValidateInteractionMode"
      :vid="validationProviderRef"
      :debounce="validationDelay"
    >
      <v-treeview
        v-model="node"
        activatable
        :search="search"
        :items="items"
        :itemKey="itemKey"
        openOnClick
        returnObject
        @update:active="updateData"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    components: {
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        itemKey: {
            type: String,
            default: 'id',
        },
    },
    data() {
        return {
            search: null,
            node: [],
        };
    },
    methods: {
        updateData(e) {
            if (e?.length && e[0].nodeType !== 'Component') {
                this.$toasted.global.toast_error({
                    // eslint-disable-next-line vue-i18n/no-missing-keys
                    message: this.$t('forms.errors.selectComponent'),
                });
                return;
            }
            this.node = e;
            this.$emit('input', e);
        },
    },
};
</script>
